export const recapQuestion = (content)=>{
    if (content.type === 'simple-confirmation') return content.question;
    if (content.type === 'confirmation-summary' || content.type === 'confirmation-hierarchy' || content.type === 'list-select' || content.type === 'list-select-multi' || content.type === 'numbered-list') {
        return content.intro;
    }
    return '';
};
export const oxfordList = (parts)=>{
    if (parts.length === 0) return '';
    if (parts.length === 1) return parts[0];
    if (parts.length === 2) return "".concat(parts[0], " and ").concat(parts[1]);
    return "".concat(parts.slice(0, -1).join(', '), ", and ").concat(parts[parts.length - 1]);
};
export const formatAddOnly = (parts, copy)=>{
    if (parts.length === 0) return copy.none;
    return copy.addOnly(oxfordList(parts));
};
export const summaryItemsUserBubble = (items, selectedItemIds, copy)=>formatAddOnly(items.filter((i)=>selectedItemIds.includes(i.id)).map((i)=>i.name), copy);
export const hierarchyUserBubble = (sections, selectedItemIds, copy)=>{
    const parts = sections.map((section)=>({
            title: section.title,
            count: section.items.filter((i)=>selectedItemIds.includes(i.id)).length
        })).filter((p)=>p.count > 0).map((p)=>copy.hierarchySectionPart(p.count, p.title));
    return formatAddOnly(parts, copy);
};
export const numberedListUserBubble = (content, selectedItemIds)=>{
    const id = selectedItemIds[0];
    if (id == null) return null;
    const option = content.options.find((o)=>o.id === id);
    return option != null ? option.label : null;
};
export const listSelectUserBubble = (content, selectedItemIds)=>{
    const id = selectedItemIds[0];
    if (id == null) return null;
    const item = content.items.find((i)=>i.id === id);
    return item != null ? item.title : null;
};
export const listSelectMultiUserBubble = (content, selectedItemIds, copy)=>formatAddOnly(content.items.filter((i)=>selectedItemIds.includes(i.id)).map((i)=>i.name), copy);
const itemsOfCard = (content)=>{
    if (content.type === 'confirmation-summary') return content.items;
    if (content.type === 'confirmation-hierarchy') return content.sections.flatMap((s)=>s.items);
    if (content.type === 'list-select') return content.items;
    if (content.type === 'list-select-multi') return content.items;
    return [];
};
export const isFullApply = (content, selectedItemIds)=>{
    const all = itemsOfCard(content);
    if (all.length === 0) return false;
    const selected = new Set(selectedItemIds);
    if (selected.size !== all.length) return false;
    return all.every((i)=>selected.has(i.id));
};
export const userActionOf = (message)=>{
    if (message == null || message.role !== 'user') return null;
    if (message.content.type === 'apply') {
        return {
            kind: 'apply',
            messageId: message.content.messageId,
            selectedItemIds: message.content.selectedItemIds
        };
    }
    if (message.content.type === 'dismiss') {
        return {
            kind: 'dismiss',
            messageId: message.content.messageId
        };
    }
    if (message.content.type === 'prompt') {
        return {
            kind: 'prompt',
            text: message.content.text
        };
    }
    return null;
};
